import { render, staticRenderFns } from "./JobSavedSearches.vue?vue&type=template&id=0be3780d&lang=pug&"
import script from "./JobSavedSearches.vue?vue&type=script&lang=ts&"
export * from "./JobSavedSearches.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0be3780d')) {
      api.createRecord('0be3780d', component.options)
    } else {
      api.reload('0be3780d', component.options)
    }
    module.hot.accept("./JobSavedSearches.vue?vue&type=template&id=0be3780d&lang=pug&", function () {
      api.rerender('0be3780d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jobsearch-pages/JobSavedSearches.vue"
export default component.exports